import YesNo from '@/components/reporting/types/YesNo';
import RatingScale from '@/components/reporting/types/RatingScale';

export class ReportingQuestionFactory {
  static make(type) {
    switch (type) {
      case 'Yes/No':
      case 'Yes/No/Alt':
        return YesNo;

      case 'Rating Scale':
        return RatingScale;

      // case 'Comment':
      //     return Comment;

      default:
        return () => {};
    }
  }
}
